export const GET_ALL_FILES = "GET_ALL_FILES";
export const START_LOADING_FILES = "START_LOADING_FILES";
export const STOP_LOADING_FILES = "STOP_LOADING_FILES";
export const ERROR_LOADING_FILES = "ERROR_LOADING_FILES";
export const RESET_FILES_FILTER_ACTIONS = "RESET_FILES_FILTER_ACTIONS";
